<template>
  <PublicLayout>
    <div class="h-dvh align-middle">
      <h1>{{ error.status }}</h1>
      <p class="mt-20">{{ error.message }}</p>
      <NuxtLink to="/">Вернуться на главную</NuxtLink>
    </div>
  </PublicLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'
import PublicLayout from './layouts/PublicLayout.vue'

defineProps<{ error: NuxtError }>()
</script>
